import { BehavioralEventSelect } from './BehavioralEventSelect';
import { InsightsTimeframePicker } from './InsightsTimeframePicker';
import { BehaviorInsightsActionsWrapper } from './BehaviorInsights.styled';

export const BehaviorInsightsActions = () => {
  return (
    <BehaviorInsightsActionsWrapper>
      <InsightsTimeframePicker />
      <BehavioralEventSelect />
    </BehaviorInsightsActionsWrapper>
  );
};
